import { HttpRequestError } from './error'
import { translateWithFallback } from './i18n'

class LoginError {
  constructor(errors, defaultMessage) {
    const { message, data, status } = HttpRequestError.parse(errors)
    const listOfError = data.errors || []
    const firstError = listOfError[0] || {}
    const { errorCode, data: errorData } = firstError
    const errorMessage = defaultMessage || data.message || message
    const { maxPinLoginReached, maxLoginReached, maxResendOtpReached } =
      errorData || {}

    this.maxLoginReached = maxLoginReached || false
    this.maxPinLoginReached = maxPinLoginReached || false
    this.maxResendReached = maxResendOtpReached || status === 403
    this.errorMessage = translateWithFallback(
      errorCode,
      errorData,
      errorMessage
    )
  }

  getCode = () => {
    return this.errorCode
  }

  isMaxPinLoginReached = () => {
    return this.maxPinLoginReached || false
  }

  isMaxLoginReached = () => {
    return this.maxLoginReached || false
  }

  isMaxResendReached = () => {
    return this.maxResendReached || false
  }

  getMessage = () => {
    return this.errorMessage || ''
  }
}

export default LoginError
